import { Link, Typography } from '@customink/pigment-react';
import {
  useConfigContext,
  useProduct,
} from '@customink/project-service-react-components';
import type { ReactEventHandler } from 'react';

type ProductAvailabilityProps = {
  colorId?: number;
};

export const ProductAvailability = ({ colorId }: ProductAvailabilityProps) => {
  const { sizingUrl } = useConfigContext();
  const { data: product } = useProduct({ colorId });
  const productColor = product?.colors?.find((color) => color.id === colorId);

  const hasInactiveSizes = productColor?.sizes?.some(
    (size) => size.status !== 'active',
  );

  const openAvailibilityGuide: ReactEventHandler = (event) => {
    event?.stopPropagation();
    window.open(
      `${sizingUrl}/${product?.id}`,
      'window',
      'width=700height,height=700,scrollbars=yes,toolbar=yes,menubar=no,location=yes,resizable=yes',
    );
  };
  const showAvailabilityInfo = sizingUrl && product?.id && hasInactiveSizes;

  if (!showAvailabilityInfo) return null;

  return (
    <Typography color="text.secondary" variant="uiTextTiny">
      Note: Some sizes are currently out of stock in this color. View
      <Link
        onClick={openAvailibilityGuide}
        rel="noreferrer noopener"
        target="_blank"
      >
        {' '}
        size/color availability chart{' '}
      </Link>
      for in-stock options.
    </Typography>
  );
};
